import {api} from '../../../shared';
import {
  RegionsFilter,
  RegionModel,
  RegionWithMetaModel,
  CreateRegionDTO,
  EditRegionDTO,
  EditRegionParams,
} from '../model';

export const regionsApi = {
  getRegions: async (params: RegionsFilter = {}): Promise<RegionWithMetaModel> => {
    const {data} = await api.get<RegionWithMetaModel>('/api/fundraising/admin/regions', {params});
    return data;
  },

  createRegion: async (region: CreateRegionDTO): Promise<RegionModel> => {
    const {data} = await api.post<RegionModel>('/api/fundraising/admin/regions', region);
    return data;
  },

  getRegionById: async (regionId: string): Promise<RegionModel> => {
    const {data} = await api.get<RegionModel>(`/api/fundraising/admin/regions/${regionId}`);
    return data;
  },

  updateRegion: async ({regionId, name, order}: EditRegionParams): Promise<RegionModel> => {
    const body: EditRegionDTO = {name, order};
    const {data} = await api.post<RegionModel>(`/api/fundraising/admin/regions/${regionId}`, body);
    return data;
  },

  deleteRegion: async (regionId: string): Promise<void> => {
    await api.delete(`/api/fundraising/admin/regions/${regionId}`);
  },
};
